import { useMediaQuery } from '@voll-intelligence/ui-kit/hooks/use-media-query';

/** A preferência do sistema por menos movimento. */
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

/**
 * A classe que PARA o pulso do `Skeleton` do ui-kit quando a pessoa pediu menos
 * movimento: o `cn` do primitivo resolve o conflito com o `animate-pulse` da
 * base e fica o `animate-none`. Lida em JS, e não como `motion-reduce:` no CSS
 * do primitivo, porque o primitivo é do time de design; aqui ela vale para as
 * esperas LONGAS da página de resultados (a busca de hotel leva 17–45 s, A6 do
 * QA de 29/09), onde um pulso contínuo mais incomoda.
 */
export function useSkeletonMotion(): string {
  return useMediaQuery(REDUCED_MOTION_QUERY) ? 'animate-none' : '';
}
